// components/PushPermissionModal.tsx
import { useEffect, useState } from "react";
import { getToken, isSupported } from "firebase/messaging";
import { messaging } from "../lib/firebase";
import { supabase } from "../lib/supabaseClient";

export default function PushPermissionModal({ userId }: { userId: string }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!userId) return;

    const hasSeen = localStorage.getItem("push-info-shown");
    if (!hasSeen) {
      setShow(true);
    }
  }, [userId]);

  const handleAccept = async () => {
    localStorage.setItem("push-info-shown", "1");
    setShow(false);

    const supported = await isSupported();
    if (!supported) {
      alert("❌ Push wird von deinem Browser nicht unterstützt.");
      return;
    }

    try {
      const token = await getToken(messaging, {
        //vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
        vapidKey:
          "BLBMpj-QGt45qj8nG8OeJS9GDGKk4AThrROZ3FHDQ29HsQPkChOdIo8Hv4V5ouGHIV_FSG7CuOwCgiyFMQz7w6Y",
      });

      if (token) {
        const { error } = await supabase.from("user_push_tokens").upsert({
          user_id: userId,
          token,
        });

        if (error) {
          console.error("❌ Fehler beim Speichern:", error.message);
        }
      } else {
        console.warn("⚠️ Kein Token erhalten (vielleicht verweigert?)");
      }
    } catch (err) {
      console.error("❌ Fehler bei getToken:", err);
    }
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
      <div className="bg-[#161b27] rounded-2xl border border-[#2a3347] p-6 w-full max-w-md">
        <h2 className="text-sm font-semibold text-slate-100 mb-3">🔔 Push-Benachrichtigungen</h2>
        <p className="text-xs text-slate-400 mb-5">
          Möchtest du in Zukunft wichtige Infos direkt als Nachricht auf dein
          Gerät erhalten? Du kannst dies später im Profil ändern.
        </p>
        <div className="flex justify-end gap-2">
          <button
            className="text-xs px-3 py-1.5 rounded-full bg-[#1e2639] text-slate-400 hover:text-slate-200 transition-colors"
            onClick={() => {
              localStorage.setItem("push-info-shown", "1");
              setShow(false);
            }}
          >
            Später
          </button>
          <button
            className="text-xs px-3 py-1.5 rounded-full bg-sky-600 text-white hover:bg-sky-500 transition-colors"
            onClick={handleAccept}
          >
            Aktivieren
          </button>
        </div>
      </div>
    </div>
  );
}
